/** YouTube embed / pause-mark helpers for scenario video playback. */

export function extractYoutubeId(value) {
  if (!value) return null;
  const match = String(value).match(
    /(?:youtube\.com\/embed\/|youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
  );
  return match ? match[1] : null;
}

export function formatPauseClock(totalSeconds) {
  const seconds = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${String(secs).padStart(2, '0')}`;
}

export function buildYoutubeEmbedSrc(videoId, { startSeconds } = {}) {
  const params = new URLSearchParams({
    rel: '0',
    modestbranding: '1',
    playsinline: '1',
    enablejsapi: '1',
  });
  if (typeof window !== 'undefined' && window.location?.origin) {
    params.set('origin', window.location.origin);
  }
  if (Number.isFinite(startSeconds) && startSeconds > 0) params.set('start', String(Math.floor(startSeconds)));
  return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
}

export function injectYoutubeTiming(html, { startSeconds } = {}) {
  if (!html) return html;

  return String(html).replace(/src=(["'])(.*?)\1/i, (full, quote, src) => {
    if (!/youtube\.com\/embed\//i.test(src)) return full;
    try {
      const url = new URL(src, window.location.origin);
      if (Number.isFinite(startSeconds) && startSeconds > 0) url.searchParams.set('start', String(Math.floor(startSeconds)));
      url.searchParams.set('enablejsapi', '1');
      url.searchParams.set('rel', '0');
      if (window.location?.origin) url.searchParams.set('origin', window.location.origin);
      return `src=${quote}${url.toString()}${quote}`;
    } catch {
      return full;
    }
  });
}

export function normalizePauseMarks(marks, fallback) {
  const list = (Array.isArray(marks) ? marks : [])
    .map((value) => Number(value))
    .filter((value) => Number.isFinite(value))
    .sort((a, b) => a - b);
  if (list.length) return [...new Set(list.map((value) => Math.round(value * 10) / 10))];
  if (Number.isFinite(Number(fallback))) return [Number(fallback)];
  return [];
}

export function nextPauseAfter(marks, fromSeconds) {
  const from = Number(fromSeconds) || 0;
  return marks.find((mark) => mark > from + 0.35);
}
